import { Bar, mixins } from 'vue-chartjs'
export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options', 'cssClasses', 'height', 'width', 'styles'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/views/chartbar.js